import api from '../../services/api';

/*
 * The requests the legacy webhook components made, with the same paths. Every
 * `setting_webhooks` endpoint resolves the company from `request.user.seller`.
 */

export const getSettingWebhooksRequest = () => api.get('companies/setting_webhooks/');

export const createSettingWebhookRequest = (payload) =>
  api.post('companies/setting_webhooks/create', { setting_webhook: payload });

export const updateSettingWebhookRequest = (id, payload) =>
  api.patch(`companies/setting_webhooks/update/${id}/`, { setting_webhook: payload });

export const deleteSettingWebhookRequest = (id) =>
  api.delete(`companies/setting_webhooks/delete/${id}`);
